import styled from 'styled-components';
import Offer from './Offer';
import { media } from 'utils/style';

export default styled(Offer)`
  .offer {
    & > div {
      margin-bottom: 1.6rem;
    }

    ${media.greaterThan('tablet')`
      display: flex;

      & > div {
        margin-bottom: 0;
      }

      & > div:nth-child(1) {
        flex-grow: 1;
      }

      & > div:nth-child(2) {
        flex-grow: 0;
      }

      & > div:nth-child(3) {
        flex-grow: 0;
      }
    `}

    &__price-container {
      display: flex;
      justify-content: flex-end;
      min-width: 96px;
    }
  }
`;
